import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from 'store/rootReducer';
import Container from 'react-bootstrap/Container';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Nav } from 'react-bootstrap';
import WizardBanner from '../../components/wizardBanner/WizardBanner';
import { LinkContainer } from 'react-router-bootstrap';
import { Route } from 'react-router-dom';
import StartMockingBtn from './StartMockingButton/StartMockingBtn';
import MockServiceGroups from './Tabs/Groups/MockServiceGroups';
import MockServices from './Tabs/MockServices/MockServices';
import TemplatesTabContent from './Tabs/MockTemplates/TemplatesTabContent';
import { isGroupsFeatureEnabled } from '../../utils/bzmUserConfigUtil';
import MixpanelService from '../../utils/mixpanelService';
import { OPEN_MOCK_SERVICE_TAB } from '../../utils/mixpanelEvents';

type MockServicesProps = StateProps & DispatchProps & WithTranslation;

class MockServiceTabs extends Component<MockServicesProps, any> {
  getNavigationTabs = () => {
    return (
      <Nav variant="tabs" className="mb-0 position-relative">
        {!this.props.showStartMockingBanner && <StartMockingBtn />}
        <Nav.Item
          onClick={() => {
            MixpanelService.track(OPEN_MOCK_SERVICE_TAB('Virtual Services'));
          }}
        >
          <LinkContainer to="/mock-services/" exact={true}>
            <Nav.Link href="/mock-services/" active={false}>
              Virtual Services
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>

        {isGroupsFeatureEnabled() && (
          <Nav.Item
            onClick={() => {
              MixpanelService.track(OPEN_MOCK_SERVICE_TAB('Virtual Service Groups'));
            }}
          >
            <LinkContainer to="/mock-services/groups">
              <Nav.Link href="/mock-services/groups" active={false}>
                Virtual Service Groups
              </Nav.Link>
            </LinkContainer>
          </Nav.Item>
        )}

        <Nav.Item
          onClick={() => {
            MixpanelService.track(OPEN_MOCK_SERVICE_TAB('Virtual Service Templates'));
          }}
        >
          <LinkContainer to="/mock-services/templates">
            <Nav.Link href="/mock-services/templates" active={false}>
              Virtual Service Templates
            </Nav.Link>
          </LinkContainer>
        </Nav.Item>
      </Nav>
    );
  };

  render() {
    return (
      <>
        {/* Start Mocking Now Banner */}
        {this.props.showStartMockingBanner && (
          <Container fluid>
            <WizardBanner />
          </Container>
        )}

        <Container fluid>
          {this.getNavigationTabs()}
          <Route exact={true} path="/mock-services" render={() => <MockServices />} />
          <Route path="/mock-services/detail/:mockServiceId" render={() => <MockServices />} />
          <Route path="/mock-services/groups" render={() => <MockServiceGroups />} />
          <Route path="/mock-services/templates" render={() => <TemplatesTabContent />} />
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  showStartMockingBanner: state.ui.showStartMockingBanner,
});

const mapDispatchToProps = {};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default withTranslation('mockServices')(connect(mapStateToProps, mapDispatchToProps)(MockServiceTabs));
